var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services-configuration-cell"},[_c('div',{staticClass:"services-configuration-cell__content"},_vm._l((_vm.getAllServices),function(serviceName){return _c('service-icon',{key:serviceName,staticClass:"services-configuration-cell__content__item",attrs:{"name":serviceName}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }